const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/sections/EinwArzt.tsx';
import { forwardRef } from 'react';
import _ from 'lodash';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { useText } from '@cistec/common_web/utils/intlUtils';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { ArztBlock, ArztFieldsConfig } from 'App/components/eCheckin/components/fields/ArztBlock';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { generatePaths } from 'App/components/eCheckin/utils';
import textMap from '../translations';
import { EinweisungField } from './fields/EinweisungField';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    streetAndNumber: {
        required: false,
    },
    country: {
        included: false,
    },
};

const fieldsConfig: ArztFieldsConfig = {
    tel: {
        required: false,
    },
};

export const EinwArzt = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATHS = generatePaths(path, ['assignment'] as const);

    const formData = useCIS4mData();
    const assignmentIsSpecialist = _.get(formData, PATHS.assignment) === 'specialist';

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <EinweisungField label={textMap.assignment} path={PATHS.assignment} required />
            <ArztBlock
                basePath={path}
                addressFieldsConfig={addressFieldsConfig}
                fieldsConfig={fieldsConfig}
                hidden={!assignmentIsSpecialist}
                required
            />
        </ECheckinSection>
    );
});

EinwArzt.displayName = 'EinwArzt';

export default EinwArzt;
